import { getJWTPayload } from "@/getinfo-api/auth";
import store from "@/store";

export function getCurrentUserId() {
  let payload = getJWTPayload();

  if (payload) {
    return payload.id;
  } else {
    return "";
  }
}
export function getCurrentCompanyId() {
  return store.getters?.selectedCompany?.id
    ? store.getters?.selectedCompany?.id
    : localStorage.getItem("selectedCompany");
}

export function currentUserIsCompanyOwner() {
  return localStorage.getItem("ownerSelectedCompany")
    ? localStorage.getItem("ownerSelectedCompany") === getCurrentUserId()
    : false;
}

export function getCurrentEmployee() {
  let employee: any = localStorage.getItem("employee");
  if (employee || store.getters?.userIsEmployee)
    return store.getters?.userIsEmployee
      ? store.getters?.userIsEmployee
      : JSON.parse(employee);
}

export function isDocumentManager(): boolean {
  return getCurrentEmployee()?.roles?.includes("document_manager");
}

export function isLearningRequestManager(): boolean {
  return getCurrentEmployee()?.roles?.includes("learning_request_manager");
}

export function isContentManager(): boolean {
  return getCurrentEmployee()?.roles?.includes("content_manager");
}

export function isRoot() {
  let payload = getJWTPayload();

  if (payload) {
    return payload.roles.includes("ROLE_SUPER_ADMIN");
  } else {
    return false;
  }
}
